import isNil from 'lodash-es/isNil';
import { MediaPlayerError } from '@yi/core';

import { nr } from '~/common';

import type { ExtendedBrightcovePlayer } from '../../types';

import iconSrc from './icon-rewind-10-square.svg';
import { CONTROL_BAR_CLASS_NAME, PLAY_CONTROL_CLASS_NAME } from '../../brightcove-constants';

function rewind10Sec(player: ExtendedBrightcovePlayer) {
  const currentTime = player.currentTime();
  const nextTime = Math.max(currentTime - 10, 0);
  player.currentTime(nextTime);
}

export function addRewind10SecButton(
  player: ExtendedBrightcovePlayer,
  { title = '' }: { title?: string },
): void {
  const controlBar = player.$(`.${CONTROL_BAR_CLASS_NAME}`);
  if (isNil(controlBar)) {
    nr.noticeError(new MediaPlayerError('brightove player control bar is unavailable'));
    return;
  }

  const insertAfterElement = player.$(`.${PLAY_CONTROL_CLASS_NAME}`);
  if (isNil(insertAfterElement)) {
    nr.noticeError(new MediaPlayerError('insertAfterElement is unavailable'));
    return;
  }

  function onClick() {
    rewind10Sec(player);
  }

  const ButtonEl = document.createElement('button');
  ButtonEl.className = 'vjs-rewind-n-seconds vjs-control vjs-menu-button';
  ButtonEl.setAttribute('aria-label', title);
  ButtonEl.setAttribute('title', title);
  ButtonEl.addEventListener('click', onClick);

  const icon = document.createElement('img');
  icon.setAttribute('src', iconSrc);
  icon.setAttribute('aria-label', 'rewind 10 seconds icon');
  icon.style.height = '100%';
  icon.style.userSelect = 'none';
  ButtonEl.appendChild(icon);

  controlBar.insertBefore(ButtonEl, insertAfterElement.nextSibling);
  player.on('dispose', () => {
    // clean up listeners to prevent memory leakages
    ButtonEl.removeEventListener('click', onClick);
  });
}
